import CategoryCard from "./CategoryCard";
import styles from "./CategoryGrid.module.css";

export default function CategoryGrid({ categories }) {
  return (
    <section className={styles.grid}>
      {categories.map((category) => (
        <CategoryCard key={category.title} {...category} />
      ))}
    </section>
  );
}
